// Converted to lazy loading
const employeesIndex = () => import('@/pages/employees/employees/index.vue')
const employeesForm = () => import('@/pages/employees/employees/form.vue')
const employeesShow = () => import('@/pages/employees/employees/show.vue')

const employeesSalariesIndex = () => import('@/pages/employees/employeesSalaries/index.vue')
const employeesSalariesForm = () => import('@/pages/employees/employeesSalaries/form.vue')
const employeesSalariesShow = () => import('@/pages/employees/employeesSalaries/show.vue')

const employeesSalarySheetsIndex = () => import('@/pages/employees/employeesSalarySheets/index.vue')
const employeesSalarySheetsForm = () => import('@/pages/employees/employeesSalarySheets/form.vue')
const employeesSalarySheetsShow = () => import('@/pages/employees/employeesSalarySheets/show.vue')

const employeesIncentivesIndex = () => import('@/pages/employees/employeesIncentives/index.vue')
const employeesIncentivesForm = () => import('@/pages/employees/employeesIncentives/form.vue')
const employeesIncentivesShow = () => import('@/pages/employees/employeesIncentives/show.vue')

const employeesDeductionsIndex = () => import('@/pages/employees/employeesDeductions/index.vue')
const employeesDeductionsForm = () => import('@/pages/employees/employeesDeductions/form.vue')
const employeesDeductionsShow = () => import('@/pages/employees/employeesDeductions/show.vue')

const employeesWithdrawalsIndex = () => import('@/pages/employees/employeesWithdrawals/index.vue')
const employeesWithdrawalsForm = () => import('@/pages/employees/employeesWithdrawals/form.vue')
const employeesWithdrawalsShow = () => import('@/pages/employees/employeesWithdrawals/show.vue')

const shiftsIndex = () => import('@/pages/employees/shifts/index.vue')
const shiftsForm = () => import('@/pages/employees/shifts/form.vue')
const shiftsShow = () => import('@/pages/employees/shifts/show.vue')

const employeesShiftsIndex = () => import('@/pages/employees/employeesShifts/index.vue')
const employeesShiftsForm = () => import('@/pages/employees/employeesShifts/form.vue')
const employeesShiftsShow = () => import('@/pages/employees/employeesShifts/show.vue')

const employeesShiftsAttendanceIndex = () =>
  import('@/pages/employees/employeesShiftsAttendance/index.vue')
const employeesShiftsAttendanceForm = () =>
  import('@/pages/employees/employeesShiftsAttendance/form.vue')
const employeesShiftsAttendanceShow = () =>
  import('@/pages/employees/employeesShiftsAttendance/show.vue')

const penaltiesIndex = () => import('@/pages/employees/penalties/index.vue')
const penaltiesForm = () => import('@/pages/employees/penalties/form.vue')
const penaltiesShow = () => import('@/pages/employees/penalties/show.vue')

const employeesVacationsIndex = () => import('@/pages/employees/employeesVacations/index.vue')
const employeesVacationsForm = () => import('@/pages/employees/employeesVacations/form.vue')
const employeesLogsIndex = () => import('@/pages/employees/employeesLogs/index.vue')
const employeesLogsForm = () => import('@/pages/employees/employeesLogs/form.vue')
// const employeesVacationsShow = () => import('@/pages/employees/employeesVacations/show.vue')
const routes = [
  {
    path: 'employees',
    name: 'employees',
    component: employeesIndex
  },
  {
    path: 'employees/create',
    name: 'employeesCreate',
    component: employeesForm
  },
  {
    path: 'employees/:id/edit',
    name: 'employeesEdit',
    component: employeesForm
  },
  {
    path: 'employees/:id',
    name: 'employeesShow',
    component: employeesShow
  },

  //employees salaries
  {
    path: 'employeesSalaries',
    name: 'employeesSalaries',
    component: employeesSalariesIndex
  },
  {
    path: 'employeesSalaries/create',
    name: 'employeesSalariesCreate',
    component: employeesSalariesForm
  },
  {
    path: 'employeesSalaries/:id/edit',
    name: 'employeesSalariesEdit',
    component: employeesSalariesForm
  },
  {
    path: 'employeesSalaries/:id',
    name: 'employeesSalariesShow',
    component: employeesSalariesShow
  },
  {
    path: 'employeesSalarySheets',
    name: 'employeesSalarySheets',
    component: employeesSalarySheetsIndex
  },
  {
    path: 'employeesSalarySheets/create',
    name: 'employeesSalarySheetsCreate',
    component: employeesSalarySheetsForm
  },
  {
    path: 'employeesSalarySheets/:id/edit',
    name: 'employeesSalarySheetsEdit',
    component: employeesSalarySheetsForm
  },
  {
    path: 'employeesSalarySheets/:id',
    name: 'employeesSalarySheetsShow',
    component: employeesSalarySheetsShow
  },

  //employees incentives
  {
    path: 'employeesIncentives',
    name: 'employeesIncentives',
    component: employeesIncentivesIndex
  },
  {
    path: 'employeesIncentives/create',
    name: 'employeesIncentivesCreate',
    component: employeesIncentivesForm
  },
  {
    path: 'employeesIncentives/:id/edit',
    name: 'employeesIncentivesEdit',
    component: employeesIncentivesForm
  },
  {
    path: 'employeesIncentives/:id',
    name: 'employeesIncentivesShow',
    component: employeesIncentivesShow
  },

  //employees deductions
  {
    path: 'employeesDeductions',
    name: 'employeesDeductions',
    component: employeesDeductionsIndex
  },
  {
    path: 'employeesDeductions/create',
    name: 'employeesDeductionsCreate',
    component: employeesDeductionsForm
  },
  {
    path: 'employeesDeductions/:id/edit',
    name: 'employeesDeductionsEdit',
    component: employeesDeductionsForm
  },
  {
    path: 'employeesDeductions/:id',
    name: 'employeesDeductionsShow',
    component: employeesDeductionsShow
  },

  //employees withdrawals
  {
    path: 'employeesWithdrawals',
    name: 'employeesWithdrawals',
    component: employeesWithdrawalsIndex
  },
  {
    path: 'employeesWithdrawals/create',
    name: 'employeesWithdrawalsCreate',
    component: employeesWithdrawalsForm
  },
  {
    path: 'employeesWithdrawals/:id/edit',
    name: 'employeesWithdrawalsEdit',
    component: employeesWithdrawalsForm
  },

  {
    path: 'employeesWithdrawals/:id',
    name: 'employeesWithdrawalsShow',
    component: employeesWithdrawalsShow
  },
  //shifts
  {
    path: 'shifts',
    name: 'shifts',
    component: shiftsIndex
  },
  {
    path: 'shifts/create',
    name: 'shiftsCreate',
    component: shiftsForm
  },
  {
    path: 'shifts/:id/edit',
    name: 'shiftsEdit',
    component: shiftsForm
  },

  {
    path: 'shifts/:id',
    name: 'shiftsShow',
    component: shiftsShow
  },
  // employees shifts
  {
    path: 'employeesShifts',
    name: 'employeesShifts',
    component: employeesShiftsIndex
  },
  {
    path: 'employeesShifts/create',
    name: 'employeesShiftsCreate',
    component: employeesShiftsForm
  },
  {
    path: 'employeesShifts/:id/edit',
    name: 'employeesShiftsEdit',
    component: employeesShiftsForm
  },

  {
    path: 'employeesShifts/:id',
    name: 'employeesShiftsShow',
    component: employeesShiftsShow
  },

  // employees shifts Attendance
  {
    path: 'employeesShiftsAttendance',
    name: 'employeesShiftsAttendance',
    component: employeesShiftsAttendanceIndex
  },
  {
    path: 'employeesShiftsAttendance/create',
    name: 'employeesShiftsAttendanceCreate',
    component: employeesShiftsAttendanceForm
  },
  {
    path: 'employeesShiftsAttendance/:id/edit',
    name: 'employeesShiftsAttendanceEdit',
    component: employeesShiftsAttendanceForm
  },

  {
    path: 'employeesShiftsAttendance/:id',
    name: 'employeesShiftsAttendanceShow',
    component: employeesShiftsAttendanceShow
  },

  //  Penalties
  {
    path: 'penalties',
    name: 'penalties',
    component: penaltiesIndex
  },
  {
    path: 'penalties/create',
    name: 'penaltiesCreate',
    component: penaltiesForm
  },
  {
    path: 'penalties/:id/edit',
    name: 'penaltiesEdit',
    component: penaltiesForm
  },

  {
    path: 'penalties/:id',
    name: 'penaltiesShow',
    component: penaltiesShow
  },

  // employees vacations
  {
    path: 'employeesVacations',
    name: 'employeesVacations',
    component: employeesVacationsIndex
  },

  {
    path: 'employeesVacations/create',
    name: 'employeesVacationsCreate',
    component: employeesVacationsForm
  },

  {
    path: 'employeesVacations/:id/edit',
    name: 'employeesVacationsEdit',
    component: employeesVacationsForm
  },
  {
    path: 'employeesLogs',
    name: 'employeesLogs',
    component: employeesLogsIndex
  },
  {
    path: 'employeesLogs/create',
    name: 'employeesLogsCreate',
    component: employeesLogsForm
  },
  {
    path: 'employeesLogs/:id/edit',
    name: 'employeesLogsEdit',
    component: employeesLogsForm
  }
]

export default routes
